import { useRef, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { jumpToPage } from '@/features/player/playerSlice';
import { setPassageSearch } from '@/features/ui/uiSlice';
import { documentPassages } from '@/data/mockData';
// Reuse transcript panel CSS since the layout is identical
import styles from '@/components/player/TranscriptPanel/TranscriptPanel.module.css';

export default function PassagesPanel() {
  const dispatch = useAppDispatch();
  const activePage = useAppSelector((s) => s.player.activeDocumentPage);
  const search = useAppSelector((s) => s.ui.passageSearch);
  const activeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [activePage]);

  const filtered = search
    ? documentPassages.filter(
        (p) =>
          p.text.toLowerCase().includes(search.toLowerCase()) ||
          p.section.toLowerCase().includes(search.toLowerCase())
      )
    : documentPassages;

  return (
    <div className={styles.panel}>
      <div className={styles.head}>
        <h4 className={styles.headTitle}>Key Passages</h4>
        <span className={styles.headMeta}>10 indexed · 1 author</span>
      </div>

      <div className={styles.search}>
        <svg
          className={styles.searchIcon}
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          className={styles.searchInput}
          placeholder="Search within this document..."
          value={search}
          onChange={(e) => dispatch(setPassageSearch(e.target.value))}
          aria-label="Search passages"
        />
      </div>

      <div className={styles.list} role="list" aria-label="Document passages">
        {filtered.map((passage) => {
          const isActive = passage.page === activePage;
          return (
            <div
              key={passage.id}
              ref={isActive ? activeRef : undefined}
              role="listitem"
              className={`${styles.line} ${isActive ? styles.lineActive : ''}`}
              onClick={() => dispatch(jumpToPage(passage.page))}
            >
              <span className={styles.lineTime}>p.{passage.page}</span>
              <div>
                <div className={styles.lineSpeaker}>{passage.section}</div>
                <div
                  className={styles.lineText}
                  dangerouslySetInnerHTML={{ __html: passage.text }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.foot}>
        <span>Click any passage to jump</span>
        {/* <span>
          <b className={styles.footAccent}>Azure Doc AI</b> + Claude
        </span> */}
      </div>
    </div>
  );
}
